import { render, staticRenderFns } from "./PickerInputold.vue?vue&type=template&id=274c8b36&"
import script from "./PickerInputold.vue?vue&type=script&lang=ts&"
export * from "./PickerInputold.vue?vue&type=script&lang=ts&"
import style0 from "./PickerInputold.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports